import { z } from 'zod';

export const updateModuleParamsSchema = z.object({
  module_id: z.uuid('Invalid module ID'),
});

export const updateModuleSchema = z.object({
  title: z.string().min(1, 'Title is required').max(255, 'Title must be less than 255 characters').optional(),
  description: z.string().min(1, 'Description is required').optional(),
  code: z.string().min(1, 'Code is required').max(100, 'Code must be less than 100 characters').optional(),
  image_url: z.string().optional(),
  image: z.instanceof(File).optional(),
  is_active: z
    .union([z.boolean(), z.literal('true').transform(() => true), z.literal('false').transform(() => false)])
    .optional(),
});

export type UpdateModuleParamsPayload = z.infer<typeof updateModuleParamsSchema>;
export type UpdateModulePayload = z.infer<typeof updateModuleSchema>;
export type UpdateModuleInput = z.input<typeof updateModuleSchema>;
